export const EFFECT_CONFIG_PREFIX = 'effect_';

// * Effect flags should be those that can and will change frequently, and will be sent to the client in the update loop.
export enum EffectPrimitiveType {
  invisibleToOpponents = 'invisibleToOpponents',
  damageImmune = 'damageImmune',

  immobile = 'immobile',

  // Forced Movement only walks to/from a given position
  forceToEntity = 'forceToEntity',
  forceFromPoint = 'forceFromPoint',

  secureMove = 'secureMove',

  // Forced Attack uses forced movement as well, but also has an entity target for pursue.
  // - Combine with "silence" and/or "disarm" to determine whether or not the afflicted entity can act upon arrival.
  forcedCoreSkill = 'forcedCoreSkill',

  scaleMoveSpeed = 'scaleMoveSpeed',
  scaleCastRange = 'scaleCastRange',

  sumCoreSkillSpeedScalar = 'sumCoreSkillSpeedScalar',

  scaleDamageIntakeAll = 'scaleDamageIntakeAll', // Mech/Elec agnostic, scale, not supplement
  sumCoreSkillPower = 'sumCoreSkillPower', // Mech/Elec agnostic, but applies to core skill only

  scaleDamageIntakeRole = 'scaleDamageIntakeRole',

  scaleArmourMech = 'scaleArmourMech',
  scaleArmourElec = 'scaleArmourElec',

  disableCoreSkills = 'disableCoreSkills', // Core skills disabled
  secureRoleSkills = 'secureRoleSkills',
  disablePartSkills = 'disablePartSkills', // Part skills disabled
  securePartSkills = 'securePartSkills'
}
